const MODAL_SELECTOR = '[data-tour="comando-param-modal"] .modal-content'
const MODAL_TRANSITION_MS = 350

const DEMO_NOME = 'Comando de exemplo'
const DEMO_ESTRUTURA = 'ligar={estado}'

const demoPreenchido = { nome: false, estrutura: false }

const clickTab = (selector) => {
    const tabElement = document.querySelector(selector)

    if (tabElement && !tabElement.classList.contains('react-tabs__tab--selected')) {
        tabElement.click()
    }
}

const setReactInputValue = (input, value) => {
    const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set

    setter.call(input, value)
    input.dispatchEvent(new Event('input', { bubbles: true }))
}

const setReactSelectValue = (select, value) => {
    const setter = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value').set

    setter.call(select, value)
    select.dispatchEvent(new Event('change', { bubbles: true }))
}

const waitForModalReady = (tourManager) =>
    tourManager.waitForElement(MODAL_SELECTOR).then(
        () => new Promise((resolve) => setTimeout(resolve, MODAL_TRANSITION_MS))
    )
const ensureDemoCommandFilled = (tourManager) => {
    const novoParametroBtn = document.querySelector('[data-tour="comando-novo-parametro"]')

    if (novoParametroBtn && !novoParametroBtn.disabled) return Promise.resolve()

    if (!document.querySelector('[data-tour="comando-nome"] input')) {
        clickTab('[data-tour="comando-tab-comando"]')
    }

    return tourManager.waitForElement('[data-tour="comando-nome"] input').then((nomeInput) => {
        const estruturaInput = document.querySelector('[data-tour="comando-estrutura"] input')

        if (!nomeInput.value.trim()) {
            setReactInputValue(nomeInput, DEMO_NOME)
            demoPreenchido.nome = true
        }

        if (estruturaInput && !estruturaInput.value.trim()) {
            setReactInputValue(estruturaInput, DEMO_ESTRUTURA)
            demoPreenchido.estrutura = true
        }
    })
}

const limparDadosDemo = () => {
    closeParameterModal()

    if (!demoPreenchido.nome && !demoPreenchido.estrutura) return

    const limpar = () => {
        const nomeInput = document.querySelector('[data-tour="comando-nome"] input')
        const estruturaInput = document.querySelector('[data-tour="comando-estrutura"] input')

        if (demoPreenchido.nome && nomeInput?.value === DEMO_NOME) {
            setReactInputValue(nomeInput, '')
        }

        if (demoPreenchido.estrutura && estruturaInput?.value === DEMO_ESTRUTURA) {
            setReactInputValue(estruturaInput, '')
        }

        demoPreenchido.nome = false
        demoPreenchido.estrutura = false
    }

    if (document.querySelector('[data-tour="comando-nome"] input')) {
        limpar()
        return
    }

    clickTab('[data-tour="comando-tab-comando"]')
    setTimeout(limpar, 200)
}

const openParameterModal = (tourManager) => {
    if (document.querySelector(MODAL_SELECTOR)) return waitForModalReady(tourManager)

    return ensureDemoCommandFilled(tourManager)
        .then(() => {
            clickTab('[data-tour="comando-tab-parametros"]')

            return tourManager.waitForElement(() => {
                const button = document.querySelector('[data-tour="comando-novo-parametro"]')

                return button && !button.disabled ? button : null
            })
        })
        .then((button) => {
            button.click()
            return waitForModalReady(tourManager)
        })
}

const closeParameterModal = () => {
    document.querySelector('[data-tour="comando-param-fechar"]')?.click()
}

const showMultipleValues = (tourManager) => {
    const select = document.querySelector('[data-tour="comando-param-tipo"] select')

    if (select && select.value !== 'select') {
        setReactSelectValue(select, 'select')
    }

    return tourManager.waitForElement('[data-tour="comando-param-opcao"]')
}

const mostrarAviso = (message, options = {}) => {
    document.dispatchEvent(new CustomEvent('showAviso', {
        detail: {
            message,
            callback: options.callback ?? null,
            callbackClose: options.callbackClose ?? null,
            callbackLabelClose: options.callbackLabelClose ?? 'Fechar',
            callbackLabel: options.callbackLabel ?? 'Continuar',
        },
    }))
}

const AVISO_FINALIZAR_COMANDO = 'Finalize o cadastro, clique em <b>Testar</b> para liberar o botão <b>Salvar</b> e, após salvar, vincule o comando na tela de <b>Monitorado</b>.'

const AVISO_SALVAR_E_ENCAMINHAR = 'O comando que está sendo cadastrado será <b>salvo</b> e você será encaminhado à tela de <b>Monitorado</b>.'

const aguardarAvisoDeSucesso = (tourManager) =>
    tourManager.waitForElement(() => {
        const body = document.querySelector('.modal.show .modal-body')

        if (body && /sucesso/i.test(body.textContent || '')) return body

        return null
    }, 8000)

const salvarEIrParaMonitorado = (tourManager) => {
    document.querySelector('[data-tour="comando-salvar"]')?.click()
    tourManager.clearSavedProgress('comandos')

    aguardarAvisoDeSucesso(tourManager)
        .then(() => {
            document.querySelector('.modal.show .modal-footer .hdv-btn-default')?.click()

            setTimeout(() => {
                tourManager.history?.push('/monitorado')
            }, 150)
        })
        .catch(() => {
        })
}

const vincularComandoAoMonitorado = (tourManager) => {
    const saveButton = document.querySelector('[data-tour="comando-salvar"]')
    const nome = document.querySelector('[data-tour="comando-nome"] input')?.value?.trim()
    const estrutura = document.querySelector('[data-tour="comando-estrutura"] input')?.value?.trim()
    const usandoDadosDemo =
        (demoPreenchido.nome && nome === DEMO_NOME) ||
        (demoPreenchido.estrutura && estrutura === DEMO_ESTRUTURA)

    if (!saveButton || saveButton.disabled || !nome || !estrutura || usandoDadosDemo) {
        tourManager.finish('comandos')
        mostrarAviso(AVISO_FINALIZAR_COMANDO)
        return
    }

    tourManager.setTourCleanup?.(null)
    tourManager.minimize()

    mostrarAviso(AVISO_SALVAR_E_ENCAMINHAR, {
        callback: () => salvarEIrParaMonitorado(tourManager),
        callbackClose: () => tourManager.clearSavedProgress('comandos'),
        callbackLabelClose: 'Cancelar',
    })
}

const bindVincularMonitoradoLink = (tourManager) => {
    setTimeout(() => {
        const link = document.querySelector(
            '.driver-popover-description [data-hdv-vincular-comando-monitorado]'
        )

        if (!link || link._hdvVincularComandoBound) return

        link._hdvVincularComandoBound = true
        link.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            vincularComandoAoMonitorado(tourManager)
        })
    }, 0)
}

const buildComandosTourSteps = (tourManager) => {
    demoPreenchido.nome = false
    demoPreenchido.estrutura = false

    tourManager.setTourCleanup?.(() => limparDadosDemo())

    return [
        {
            popover: {
                title: 'Cadastro de comando',
                description: 'Neste guia você vai configurar uma mensagem que poderá ser enviada ao equipamento. O cadastro é dividido nas abas Comando e Parâmetros.',
            },
        },
        {
            element: '[data-tour="comando-tab-comando"]',
            popover: {
                title: 'Aba Comando',
                description: 'Aqui você define o nome e o formato da mensagem que será enviada ao equipamento.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    clickTab('[data-tour="comando-tab-comando"]')
                    setTimeout(() => tourManager.moveNext(), 150)
                },
            },
        },
        {
            element: '[data-tour="comando-nome"]',
            popover: {
                title: 'Nome do comando',
                description: 'Dê um nome fácil de reconhecer, como “Ligar bomba” ou “Alterar intervalo”.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="comando-estrutura"]',
            popover: {
                title: 'Estrutura do comando',
                description: 'Digite a mensagem que o equipamento deve receber. Para usar um valor variável, escreva o ID do parâmetro entre chaves, por exemplo: ligar={estado}.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="comando-formula"]',
            popover: {
                title: 'Fórmula do comando',
                description: 'Depois do teste, este campo mostra a mensagem final já com os valores escolhidos. Assim você confere exatamente o que será enviado.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="comando-valores-teste"]',
            popover: {
                title: 'Valores para teste',
                description: 'Os parâmetros cadastrados aparecem aqui. Informe ou escolha valores para simular o comando antes de salvá-lo.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="comando-testar"]',
            popover: {
                title: 'Testar comando',
                description: 'Clique para montar e validar a mensagem final. O botão Salvar só é liberado quando o teste estiver correto.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="comando-tab-parametros"]',
            popover: {
                title: 'Aba Parâmetros',
                description: 'Use esta aba para criar os valores variáveis usados na estrutura do comando. Clique em <strong>Próximo</strong> para abri-la.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    clickTab('[data-tour="comando-tab-parametros"]')
                    setTimeout(() => tourManager.moveNext(), 150)
                },
                onPrevClick: () => {
                    clickTab('[data-tour="comando-tab-comando"]')
                    setTimeout(() => tourManager.movePrevious(), 150)
                },
            },
        },
        {
            element: '[data-tour="comando-novo-parametro"]',
            popover: {
                title: 'Novo parâmetro',
                description: 'Crie um parâmetro para cada parte variável da mensagem. Clique em <strong>Próximo</strong> para conhecer as opções do cadastro.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    openParameterModal(tourManager)
                        .then(() => tourManager.moveNext())
                        .catch(() => {})
                },
            },
        },
        {
            element: '[data-tour="comando-param-nome"]',
            ensureReady: () => openParameterModal(tourManager),
            popover: {
                title: 'Nome do parâmetro',
                description: 'Informe um nome que explique o valor solicitado ao usuário, como “Estado” ou “Tempo em segundos”.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => {
                    closeParameterModal()
                    setTimeout(() => tourManager.movePrevious(), 250)
                },
            },
        },
        {
            element: '[data-tour="comando-param-id"]',
            ensureReady: () => openParameterModal(tourManager),
            popover: {
                title: 'ID do parâmetro',
                description: 'Crie um identificador único e use exatamente o mesmo ID entre chaves na estrutura do comando.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="comando-param-tipo"]',
            ensureReady: () => openParameterModal(tourManager),
            popover: {
                title: 'Tipo do valor',
                description: 'Valor único permite digitação livre. Múltiplos valores oferece uma lista de opções prontas. Clique em <strong>Próximo</strong> para ver como configurar a lista.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    showMultipleValues(tourManager)
                        .then(() => tourManager.moveNext())
                        .catch(() => {})
                },
            },
        },
        {
            element: '[data-tour="comando-param-opcao-descricao"]',
            ensureReady: () => showMultipleValues(tourManager),
            popover: {
                title: 'Descrição da opção',
                description: 'Digite o texto que o usuário verá na lista, como “Ligado” ou “Desligado”.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="comando-param-opcao-valor"]',
            ensureReady: () => showMultipleValues(tourManager),
            popover: {
                title: 'Valor da opção',
                description: 'Informe o valor real que será colocado no comando quando essa opção for escolhida, como 1 ou 0.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="comando-param-opcao-adicionar"]',
            ensureReady: () => showMultipleValues(tourManager),
            popover: {
                title: 'Adicionar opção',
                description: 'Depois de preencher descrição e valor, clique no botão + para incluir a opção na lista.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="comando-param-opcoes-tabela"]',
            ensureReady: () => showMultipleValues(tourManager),
            popover: {
                title: 'Opções cadastradas',
                description: 'As opções adicionadas aparecem aqui. Você pode conferir a descrição, o valor e excluir uma opção incorreta.',
                side: 'top',
                align: 'center',
            },
        },
        {
            element: '[data-tour="comando-param-confirmar"]',
            ensureReady: () => openParameterModal(tourManager).then(() => showMultipleValues(tourManager)),
            popover: {
                title: 'Adicionar parâmetro',
                description: 'Quando terminar, clique em Adicionar. Se estiver editando um parâmetro existente, este botão aparecerá como "Atualizar".',
                side: 'top',
                align: 'end',
                onNextClick: () => {
                    closeParameterModal()
                    setTimeout(() => tourManager.moveNext(), 250)
                },
            },
        },
        {
            element: '[data-tour="comando-parametros-tabela"]',
            popover: {
                title: 'Parâmetros cadastrados',
                description: 'Esta tabela reúne os parâmetros do comando. Use as ações para editar ou excluir cada item.',
                side: 'top',
                align: 'center',
                onPrevClick: () => {
                    openParameterModal(tourManager)
                        .then(() => showMultipleValues(tourManager))
                        .then(() => tourManager.movePrevious())
                        .catch(() => {})
                },
            },
        },
        {
            element: '[data-tour="comando-salvar"]',
            popover: {
                title: 'Salvar comando',
                description: 'Depois de cadastrar os parâmetros, volte à aba Comando, informe os valores e clique em Testar. Com o teste válido, este botão salva o cadastro.',
                side: 'top',
                align: 'start',
                onPrevClick: () => {
                    clickTab('[data-tour="comando-tab-parametros"]')
                    setTimeout(() => tourManager.movePrevious(), 150)
                },
            },
        },
        {
            popover: {
                title: 'Pronto!',
                description: 'Agora você já sabe montar, testar e salvar um comando. Para utilizá-lo em um Monitorado, é necessário <a href="#" class="hdv-tour-start-link" data-hdv-vincular-comando-monitorado>vincular o comando ao Monitorado</a>.<br><br>Você também pode enviá-lo manualmente pela aba <strong>Comandos</strong> do equipamento, mesmo sem esse vínculo.',
                onPrevClick: () => tourManager.movePrevious(),
            },
            onHighlighted: () => {
                clickTab('[data-tour="comando-tab-comando"]')
                bindVincularMonitoradoLink(tourManager)
            },
        },
    ]
}

export default buildComandosTourSteps
